export default {
	isLast(arr, obj){
		// sdfkonadfgkjbnak
		return arr.length -1 == arr.indexOf(obj);
	},
	moment(timestamp){
		var date = new Date(timestamp*1000);
		return date.getDate() + '.' + date.getMonth() + '.' + date.getFullYear();
	},

	toggleMy(){
		this.filters.my = !this.filters.my;
		this.$router.push({ query: {
			my: this.filters.my
		}});
		// this.update();
	},
	updateSearch(){
		var self = this;
		if(this.searchtext.length > 2){
			this.filters.q = this.searchtext;

			if (this.timeoutId) window.clearTimeout(this.timeoutId);
		  	this.timeoutId = window.setTimeout(function () {
				self.update();
		  	}, 500);

		} else if(this.filters.q.length > 0) {
			this.filters.q = '';

			if (this.timeoutId) window.clearTimeout(this.timeoutId);
		  	this.timeoutId = window.setTimeout(function () {
				self.update();
		  	}, 500);
		}
	}
};



// WEBPACK FOOTER //
// ./src/helpers/table.js